import { isNil } from 'lodash';
import React, { useState } from 'react';

import { useFormSelector, useGridTitle } from '../../../custom-hooks';
import { useWindowDimensions } from '../../../custom-hooks/useWindowDimensions';
import { getUITA, isTrue } from '../../../utils/commonUtils';
import Accordion from '../../components/Accordion';
import { FORM_MODEL_ATTRIBUTES, SS_CONTROL_TYPE } from '../../constants/form-manager.constants';
import { getEvaluatedExpression } from '../../selectors/form-manager.selectors';

const SSRuntimePanel = ({ children, id, index, isEditor, entityName, formKey }) => {
  const title = useGridTitle({ id, index, entityName });
  const header = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    entityName,
    prop: FORM_MODEL_ATTRIBUTES.HEADER,
    defaultValue: true,
  });
  const showHeader = isTrue(header) && !isNil(title);

  const { isMobileDevice } = useWindowDimensions();

  const [isCollapsed, setCollapsed] = useState(isMobileDevice);

  return (
    <div ui-ta={getUITA('FormPart', 'SSPanel')} data-ss-id={id}>
      <Accordion
        formKey={formKey}
        isCollapsed={isEditor ? false : isCollapsed}
        showHeader={showHeader}
        title={title}
        controlType={SS_CONTROL_TYPE.PANEL}
        onChange={() => setCollapsed(!isCollapsed)}
        autoScrollUpEnabled={isMobileDevice && isCollapsed}
      >
        {children}
      </Accordion>
    </div>
  );
};

export default SSRuntimePanel;
